import { useState } from 'react';
import { ANIMATIONTIMER } from '../../Constants';
import clsx from 'clsx';

function ShowdownItem({
  name,
  description,
  imageURL,
  animating,
}: {
  name: string;
  description: string;
  imageURL: string;
  animating: boolean;
}) {
  const [selectedItem, setSelectedItem] = useState(false);

  function clickRumbleItem() {
    if (!animating) {
      setSelectedItem(true);
      setTimeout(function () {
        setSelectedItem(false);
      }, ANIMATIONTIMER);
    }
  }

  return (
    <div
      style={{ backgroundImage: imageURL ? `url(${imageURL})` : '' }}
      className={clsx(
        selectedItem ? 'animate' : 'reset-animation',
        'h-[30vh] tablet:h-[50vh] bg-no-repeat bg-cover bg-center relative cursor-pointer'
      )}
      onClick={clickRumbleItem}
    >
      <div
        className={
          'absolute p-8 w-full bottom-0 text-white bg-black/[0.3] text-center'
        }
      >
        <p className={'text-24 font-semibold'}>{name}</p>
        <div>{description}</div>
      </div>
    </div>
  );
}

export default ShowdownItem;
